module.exports = "images/enfants_8.6746a1f1.png";